<nz-form-item>
  <nz-form-label *ngIf="to.label" [nzRequired]="to.required">{{
    to.label
  }}</nz-form-label>
  <nz-form-control [nzErrorTip]="errorTpl" [nzValidateStatus]="errorState">
    <nz-checkbox-group
      [nzOptions]="checkboxOptions"
      [formControl]="formControl"
    />
    <ng-template #errorTpl let-control>
      <formly-validation-message [field]="field"></formly-validation-message>
    </ng-template>
  </nz-form-control>
</nz-form-item>
